import _styled, { default as _styled2 } from "styled-components";
import type { SanityCaseStudiesFilterOption } from "~/features/sanity/case-studies/types";
import { up } from "~/features/app/screens";
import { FilterBar, type Filter } from "~/features/filter/filter-bar";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { Wrap } from "~/features/ui/wrap";
const DEFAULT_INDUSTRY = {
  label: "All",
  value: ""
};
function mapOptions(industries: SanityCaseStudiesFilterOption[]) {
  return industries.flatMap(industry => industry.title && industry.slug ? [{
    label: industry.title,
    value: industry.slug
  }] : []);
}
type Props = {
  industries?: SanityCaseStudiesFilterOption[];
  onChange: (type: string, val: string) => void;
  value: {
    industry: string;
  };
};
export function CaseStudiesFilters({
  industries = [],
  onChange,
  value
}: Props) {
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const isLg = useMediaQuery(up("lg"));
  const filters: Filter[] = [{
    title: "Industry",
    options: [DEFAULT_INDUSTRY, ...mapOptions(industries)],
    type: isLg ? "radio" : "dropdown",
    value: value.industry
  }];
  return <_StyledDiv $_css={[{
    "borderTopWidth": "1px",
    "borderBottomWidth": "1px"
  }, themeStyle.background, themeStyle.border]}>
      <Wrap mode="light">
        <_StyledDiv2>
          <span>Show</span>
          <FilterBar filters={filters} onChange={onChange} />
        </_StyledDiv2>
      </Wrap>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-z0oitu-0"
})`${p => p.$_css}`;
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "case-studies-filters___StyledDiv2",
  componentId: "sc-1lsix2w-0"
})({
  "position": "relative",
  "zIndex": "10",
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1.6rem",
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "justifyContent": "flex-start",
    "paddingLeft": "8rem",
    "paddingRight": "8rem",
    "paddingTop": "2.4rem",
    "paddingBottom": "2.4rem"
  }
});